import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';
import type { AuditFields, TimestampFields } from './types';

export interface Organization extends AuditFields, TimestampFields {
  id: string;
  name: string;
  aliases: string;
  notes: string;
  salesforceId: string;
  shortName: string;
}

export function createOrganization(data: Partial<Organization>) {
  return request(`${ROOT_SERVER_URL}/api/organizations`, {
    data,
    method: 'POST',
  });
}

export function getOrganization(organizationId: string) {
  return request(`${ROOT_SERVER_URL}/api/organizations/${organizationId}`);
}

export function getOrganizations() {
  return request(`${ROOT_SERVER_URL}/api/organizations`);
}

export function updateOrganization(organizationId: string, changes: Partial<Organization>) {
  return request(`${ROOT_SERVER_URL}/api/organizations/${organizationId}`, {
    data: changes,
    method: 'PUT',
  });
}

export function getOrganizationUsers(organizationId: string) {
  return request(`${ROOT_SERVER_URL}/api/organizations/${organizationId}/users`);
}
